import React from 'react';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';

import { InsuranceIcon } from './icons/InsurnaceIcon';

function SectionFeatures() {
  return (
    <Box
      paddingHorizontal={{ xs: '6x', md: '12x', lg: '14x' }}
      paddingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
      backgroundColor="primary.default"
      tag="section"
    >
      <Grid
        row
        spacing="0"
      >
        <Grid
          col={{ xs: 12, md: 10, lg: 5 }}
          offset={{ lg: 1 }}
        >
          <InsuranceIcon title="INSURANCE.HEAD.TITLE" />
          <Typography
            variant="title"
            color="white.default"
            marginTop={{ xs: '6x' }}
            gutterBottom={{ xs: 2.5, md: 4.5, lg: 2.375 }}
            intlKey="INSURANCE.FEATURES.TITLE"
          />
        </Grid>
        <Grid
          col={{ md: 12, lg: 10 }}
          offset={{ lg: 1 }}
        >
          <Box
            height="1px"
            backgroundColor="white.default"
            marginVertical={{ md: '8x', lg: '12x' }}
            display={{ xs: 'none', md: 'block' }}
          />
        </Grid>
        <Grid
          row
          spacing="0"
        >
          <Grid
            col={{ xs: 12, lg: 5 }}
            offset={{ lg: 1 }}
            spacingRight={{ xs: '2x', md: '4x' }}
          >
            <Typography
              variant="title"
              color="white.default"
              gutterBottom={{ xs: 0.5, md: 1.25 }}
              intlKey="INSURANCE.FEATURES.BUDGET.TITLE"
            />
            <Typography
              variant="paragraph1"
              color="white.default"
              gutterBottom={{ xs: 2.5, md: 5, lg: 2 }}
              intlKey="INSURANCE.FEATURES.BUDGET.CONTENT"
            />
          </Grid>
          <Grid col={{ xs: 12, lg: 5 }}>
            <Typography
              variant="title"
              color="white.default"
              gutterBottom={{ xs: 0.5, md: 1.25 }}
              intlKey="INSURANCE.FEATURES.SIMULATION.TITLE"
            />
            <Typography
              variant="paragraph1"
              color="white.default"
              gutterBottom={{ xs: 2.5, md: 5, lg: 2 }}
              intlKey="INSURANCE.FEATURES.SIMULATION.CONTENT"
            />
          </Grid>
          <Grid
            col={{ lg: 10 }}
            offset={{ lg: 1 }}
          >
            <Box
              height="1px"
              backgroundColor="white.default"
              marginVertical={{ md: '8x', lg: '12x' }}
              display={{ xs: 'none', lg: 'block' }}
            />
          </Grid>
          <Grid
            col={{ xs: 12, lg: 5 }}
            offset={{ lg: 1 }}
            spacingRight={{ xs: '2x', md: '4x' }}
          >
            <Typography
              variant="title"
              color="white.default"
              gutterBottom={{ xs: 0.5, md: 1.25 }}
              intlKey="INSURANCE.FEATURES.CUSTOMERS.TITLE"
            />
            <Typography
              variant="paragraph1"
              color="white.default"
              gutterBottom={{ xs: 2.5, md: 5, lg: 0 }}
              intlKey="INSURANCE.FEATURES.CUSTOMERS.CONTENT"
            />
          </Grid>
          <Grid col={{ xs: 12, lg: 5 }}>
            <Typography
              variant="title"
              color="white.default"
              gutterBottom={{ xs: 0.5, md: 1.25 }}
              intlKey="INSURANCE.FEATURES.CONDITIONS.TITLE"
            />
            <Typography
              variant="paragraph1"
              color="white.default"
              intlKey="INSURANCE.FEATURES.CONDITIONS.CONTENT"
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(SectionFeatures);

